/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create Conversation Conclusion
 * @export
 * @interface BridgeApiCreateConversationConclusion
 */
export interface BridgeApiCreateConversationConclusion {
    /**
     * 
     * @type {string}
     * @memberof BridgeApiCreateConversationConclusion
     */
    content: string;
    /**
     * Id of a conclusion template
     * @type {string}
     * @memberof BridgeApiCreateConversationConclusion
     */
    templateId: string;
}

/**
 * Check if a given object implements the BridgeApiCreateConversationConclusion interface.
 */
export function instanceOfBridgeApiCreateConversationConclusion(value: object): value is BridgeApiCreateConversationConclusion {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('templateId' in value) || value['templateId'] === undefined) return false;
    return true;
}

export function BridgeApiCreateConversationConclusionFromJSON(json: any): BridgeApiCreateConversationConclusion {
    return BridgeApiCreateConversationConclusionFromJSONTyped(json, false);
}

export function BridgeApiCreateConversationConclusionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiCreateConversationConclusion {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'templateId': json['templateId'],
    };
}

export function BridgeApiCreateConversationConclusionToJSON(json: any): BridgeApiCreateConversationConclusion {
    return BridgeApiCreateConversationConclusionToJSONTyped(json, false);
}

export function BridgeApiCreateConversationConclusionToJSONTyped(value?: BridgeApiCreateConversationConclusion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'templateId': value['templateId'],
    };
}

